export const ABT_YOURSELF = 'about-yourself';
export const METHOD_NAME = 'sendData';
export const LQ_RESPONSE = 'LQResponse';
export const SWEETNER_CONTROL_TREAT_GROUP = [
  '|FWA_Sweetener_T_Deal_P',
  '|FWA_Sweetener_T_Deal',
  '|FWA_Sweetener_C_Deal_P',
  '|FWA_Sweetener_C_Deal',
  'FWA_Sweetener_T_Deal_P',
  'FWA_Sweetener_T_Deal',
  'FWA_Sweetener_C_Deal_P',
  'FWA_Sweetener_C_Deal',
];
export const PRO_REC_T = 'pro_rec_t';
export const PRO_C = 'pro_c';
export const PRO_MAN_T = 'pro_man_t';
export const AAL_PAGES_MINI_CART = ['progressiveplan', 'addons', 'expresscheckout'];
export const MINICART_SANDBOX_T_PLANS = 'FWA_MINICART_T_Plans';
export const MINICART_THROTTLE_T = 'nos_t';
export const MINICART_SANDBOX_C_PLANS = 'FWA_MINICART_C_Plans';
export const MINICART_THROTTLE_C = 'nos_c';
export const CONTACTINFO_MODAL_T = 'FWA_CONTACTINFO_T_MODAL';
export const CONTACTINFO_THROTTLE_T = 'vac_t';
export const CONTACTINFO_MODAL_C = 'FWA_CONTACTINFO_C_MODAL';
export const CONTACTINFO_THROTTLE_C = 'vac_c';

// Tagging call type constants
export const TAGGING_CALL_TYPES = {
  LINK: 'linkCall',
  PAGE_VIEW: 'pageViewCall',
};
